"use strict";
/// <reference path="lodash-fp.d.ts" />

var _from = require("babel-runtime/core-js/array/from");

var _from2 = _interopRequireDefault(_from);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getOwnPropertySymbols = require("babel-runtime/core-js/object/get-own-property-symbols");

var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);

var _iterator = require("babel-runtime/core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("babel-runtime/core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = require("babel-runtime/core-js/object/set-prototype-of");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = _setPrototypeOf2.default || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? (0, _create2.default)(b) : (__.prototype = b.prototype, new __());
    };
}();
var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = _promise2.default))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof _symbol2.default === "function" && (g[_iterator2.default] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof _getOwnPropertySymbols2.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols2.default)(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
var next_1 = require("@alicd/next");
var LocaleProvider = require("@alicd/next/lib/locale-provider");
var CNAddressCascader_1 = require("./CNAddressCascader");
var util_1 = require("./util");
var Common_1 = require("./Common");
var lodash_alt_1 = require("./lodash-alt");
var Common_2 = require("./Common");
// qualified import for name conflict
var C = require("./Common");
var CNAddressMulti = /** @class */function (_super) {
    __extends(CNAddressMulti, _super);
    function CNAddressMulti(props) {
        var _this = _super.call(this, props) || this;
        _this.hiddenMap = {};
        _this.asyncInitialize = function () {
            return __awaiter(_this, void 0, void 0, function () {
                var defaultValue, initialValue, temps, value;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            defaultValue = this.props.defaultValue;
                            initialValue = this.props.value || defaultValue // props.defaultValue
                            ;
                            return [4 /*yield*/, this.dataset()];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.normalizeAndUpdateCascadeRoot(this.props.root)];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, _promise2.default.all(initialValue.map(function (v) {
                                return _this.normalizeValueReturningAddressAndNodeChain(v);
                            }))
                            // TODO: fix this equality logic ...
                            ];
                        case 3:
                            temps = _a.sent();
                            if (!((this.props.value || defaultValue) == initialValue)) return [3 /*break*/, 5];
                            value = temps.map(function (t) {
                                return t.address;
                            });
                            return [4 /*yield*/, this.setStateAsync({ value: value })];
                        case 4:
                            _a.sent();
                            this.triggerLabelUpdate(initialValue);
                            _a.label = 5;
                        case 5:
                            if (this.props.defaultVisible) {
                                this.setState({
                                    uiOverlayVisible: this.props.defaultVisible
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.getRequestParams = function (props) {
            if (props === void 0) {
                props = _this.props;
            }
            return {
                addressURL: props.requestAddressUrl,
                townURL: props.requestTownUrl,
                parentURL: props.requestAddressLevelUrl,
                ignored: props.ignored,
                dataOverride: props.dataOverride,
                preprocessor: props.preprocessor
            };
        };
        // TODO: this is not type safe
        _this.setStateAsync = function (updater) {
            return new _promise2.default(function (resolve, reject) {
                return _this.setState(updater, function () {
                    return resolve();
                });
            });
        };
        _this.dataset = function (params) {
            if (params === void 0) {
                params = _this.getRequestParams();
            }
            return C.dataset(_this, _this.getRequestParams());
        };
        _this.datasetImmediate = function () {
            return _this;
        };
        _this.loadAndMergeTownList = function (node, params, allNodesSetNow) {
            if (params === void 0) {
                params = _this.getRequestParams();
            }
            if (allNodesSetNow === void 0) {
                allNodesSetNow = _this.datasetImmediate().allNodesSet;
            }
            return __awaiter(_this, void 0, void 0, function () {
                var townList, nodeIsALeaf, _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            return [4 /*yield*/, util_1.loadTownData(params, node)];
                        case 1:
                            townList = _c.sent();
                            if (townList.length) {
                                node.children = townList;
                                node.isLeaf = false;
                            } else {
                                nodeIsALeaf = node;
                                nodeIsALeaf.children = undefined;
                                nodeIsALeaf.isLeaf = true;
                            }
                            _b = (_a = Object).assign;
                            return [4 /*yield*/, this.dataset()];
                        case 2:
                            _b.apply(_a, [_c.sent().allNodesSet, lodash_alt_1.zipObject(townList.map(function (t) {
                                return t.id;
                            }), townList)]);
                            if (this.datasetImmediate().allNodesSet === allNodesSetNow) {
                                this.setState({ addressTree: this.state.addressTree });
                            }
                            return [2 /*return*/, townList];
                    }
                });
            });
        };
        _this.normalizeAndUpdateCascadeRoot = function (root) {
            return __awaiter(_this, void 0, void 0, function () {
                var rootNode, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!((typeof root === "undefined" ? "undefined" : (0, _typeof3.default)(root)) == "object" && !("country" in root))) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.updateCascadeRoot_("0")];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                        case 2:
                            _a = lodash_alt_1.last;
                            return [4 /*yield*/, this.normalizeValueReturningNodeChain(root)];
                        case 3:
                            rootNode = _a.apply(void 0, [_b.sent()]);
                            // console.log("updating Cascade root", root, rootNode)
                            if (!rootNode || rootNode.isLeaf) {
                                throw new Error("invalid root node " + root + " - " + rootNode);
                            }
                            return [4 /*yield*/, this.updateCascadeRoot_(rootNode.id)];
                        case 4:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.updateCascadeRoot_ = function (root) {
            return __awaiter(_this, void 0, void 0, function () {
                var updater;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            root = root.toString();
                            updater = { cascadeRootNodeID: root };
                            if (!C.isDescendantOfOne(this.allNodesSet, this.state.expandedValue, [root])) {
                                updater.expandedValue = root;
                            }
                            return [4 /*yield*/, this.setStateAsync(updater)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        };
        // the arg value is the one cached inside CascaderSelect, not our data
        _this.handleLoadData = function (valueClone) {
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            return [4 /*yield*/, this.loadTownFromNodeId(valueClone.id)];
                        case 1:
                            return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        _this.handleExpandChange = function (expandedValue) {
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            return [4 /*yield*/, this.loadTownFromNodeId(expandedValue)];
                        case 1:
                            _a.sent();
                            this.setState({ expandedValue: expandedValue });
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.state = {
            value: [],
            cascadeRootNodeID: null,
            paneRoot: null,
            addressTree: {},
            uiOverlayVisible: false,
            expandedValue: "1"
        };
        _this.updateHiddenMap(_this.props.hiddenData);
        _this.handleCascadeChange = _this.handleCascadeChange.bind(_this);
        _this.handleLoadData = _this.handleLoadData.bind(_this);
        _this.handleOverlayVisibleChange = _this.handleOverlayVisibleChange.bind(_this);
        _this.getOverlayContainer = _this.getOverlayContainer.bind(_this);
        _this.asyncInitialize();
        return _this;
    }
    CNAddressMulti.prototype.updateHiddenMap = function (hiddenList) {
        var ret = lodash_alt_1.zipObject(hiddenList, new Array(hiddenList.length).fill(true));
        this.hiddenMap = ret;
        return ret;
    };
    CNAddressMulti.prototype.componentWillReceiveProps = function (nextProps) {
        return __awaiter(this, void 0, void 0, function () {
            var value, temps, valueNew;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ("root" in nextProps && (this.state.cascadeRootNodeID == null || !Common_2.addressEqual(nextProps.root, this.state.cascadeRootNodeID))) {
                            this.normalizeAndUpdateCascadeRoot(nextProps.root);
                        }
                        if (!("value" in nextProps)) return [3 /*break*/, 2];
                        value = nextProps.value;
                        if (value === undefined || value === null || value === "") {
                            value = [];
                        }
                        if (!Array.isArray(value)) {
                            console.error("value of CNAddressMulti must be an array!");
                        }
                        return [4 /*yield*/, _promise2.default.all(value.map(function (v) {
                            return _this.normalizeValueReturningAddressAndNodeChain(v);
                        }))
                        // TODO: equality testing
                        ];
                    case 1:
                        temps = _a.sent();
                        valueNew = temps.map(function (t) {
                            return t.address;
                        });
                        this.setState({ value: valueNew });
                        this.triggerLabelUpdate(valueNew, nextProps);
                        _a.label = 2;
                    case 2:
                        if ("hiddenData" in nextProps && this.props.hiddenData != nextProps.hiddenData) {
                            this.updateHiddenMap(nextProps.hiddenData);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CNAddressMulti.prototype.normalizeValueReturningNodeChain = function (val, params) {
        if (params === void 0) {
            params = this.getRequestParams();
        }
        return __awaiter(this, void 0, void 0, function () {
            var traceTownParentsAndUpdateIfDataNotChanged, dataset_1, addressTree, allNodesSet, val_, dataset_2, addressTree, allNodesSet, selectionChain;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        traceTownParentsAndUpdateIfDataNotChanged = function traceTownParentsAndUpdateIfDataNotChanged(town, _a) {
                            var addressTree = _a.addressTree,
                                allNodesSet = _a.allNodesSet;
                            return __awaiter(_this, void 0, void 0, function () {
                                var chain, nodeChain, node;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            return [4 /*yield*/, util_1.traceTownParents(params, town)];
                                        case 1:
                                            chain = _b.sent();
                                            nodeChain = Common_2.selectNodeFromChain(addressTree, lodash_alt_1.dropRight(1, chain)), node = lodash_alt_1.last(nodeChain);
                                            if (!node) return [3 /*break*/, 3];
                                            return [4 /*yield*/, this.loadAndMergeTownList(node, params, allNodesSet)];
                                        case 2:
                                            _b.sent();
                                            _b.label = 3;
                                        case 3:
                                            return [2 /*return*/, nodeChain.concat([allNodesSet[town.toString()]])];
                                    }
                                });
                            });
                        };
                        if (!(typeof val == "number" || typeof val == "string")) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.dataset(params)];
                    case 1:
                        dataset_1 = _a.sent();
                        addressTree = dataset_1.addressTree, allNodesSet = dataset_1.allNodesSet;
                        if (!allNodesSet[val]) return [3 /*break*/, 2];
                        return [2 /*return*/, Common_2.nodeChainFromNode(allNodesSet[val])];
                    case 2:
                        return [4 /*yield*/, traceTownParentsAndUpdateIfDataNotChanged(val, dataset_1)];
                    case 3:
                        return [2 /*return*/, _a.sent()];
                    case 4:
                        return [3 /*break*/, 11];
                    case 5:
                        if (!((typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) == "object")) return [3 /*break*/, 10];
                        val_ = val;
                        return [4 /*yield*/, this.dataset(params)];
                    case 6:
                        dataset_2 = _a.sent();
                        addressTree = dataset_2.addressTree, allNodesSet = dataset_2.allNodesSet;
                        if (!(typeof val_.town == "string" && !this.datasetImmediate().allNodesSet[val_.town])) return [3 /*break*/, 8];
                        return [4 /*yield*/, traceTownParentsAndUpdateIfDataNotChanged(val_.town, dataset_2)];
                    case 7:
                        return [2 /*return*/, _a.sent()];
                    case 8:
                        selectionChain = Common_2.selectionToChain(val_);
                        if (!selectionChain.length) {
                            return [2 /*return*/, []];
                        }
                        return [2 /*return*/, Common_2.nodeChainFromNode(allNodesSet[Common_2.maybeGet(lodash_alt_1.last(selectionChain)).toString()])];
                    case 9:
                        return [3 /*break*/, 11];
                    case 10:
                        throw "CNAddress normalizeValue(): unknown value of " + (typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) + " - " + val;
                    case 11:
                        return [2 /*return*/];
                }
            });
        });
    };
    CNAddressMulti.prototype.normalizeValueReturningAddressAndNodeChain = function (val, params) {
        return __awaiter(this, void 0, void 0, function () {
            var nodeChain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.normalizeValueReturningNodeChain(val, params)];
                    case 1:
                        nodeChain = _a.sent();
                        return [2 /*return*/, {
                            nodeChain: nodeChain,
                            address: Common_2.foldNodeChainToSelection(nodeChain)
                        }];
                }
            });
        });
    };
    // TODO: Next 1.x Select compatibility, and a little bug of TS typechecker
    CNAddressMulti.prototype.handleCascadeChange = function (values) {
        return __awaiter(this, void 0, void 0, function () {
            var ids, normalized, nodes, nodeChains, selections;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ids = values.map(function (v) {
                            return (typeof v === "undefined" ? "undefined" : (0, _typeof3.default)(v)) == "object" ? v.value : v;
                        });
                        normalized = this.normalizeSelection(ids);
                        nodes = normalized.map(function (i) {
                            return _this.datasetImmediate().allNodesSet[i.toString()];
                        });
                        nodeChains = nodes.map(Common_2.nodeChainFromNode);
                        selections = nodeChains.map(Common_2.foldNodeChainToSelection);
                        if (!!("value" in this.props)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Common_1.setStateAsync(this, { value: selections })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.props.onChange && this.props.onChange(selections, nodes);
                        return [2 /*return*/];
                }
            });
        });
    };
    CNAddressMulti.prototype.loadTownFromNode = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.level >= 4 && !value.isLeaf && (!value.children || !value.children.length) && !(value.levelKey == "town"))) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3,, 4]);
                        return [4 /*yield*/, this.loadAndMergeTownList(value)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        return [2 /*return*/, value];
                    case 5:
                        return [2 /*return*/, _promise2.default.resolve(value)];
                }
            });
        });
    };
    CNAddressMulti.prototype.handleOverlayVisibleChange = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                arg = { uiOverlayVisible: value };
                this.setState(arg);
                return [2 /*return*/];
            });
        });
    };
    CNAddressMulti.prototype.loadTownFromNodeId = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.dataset()];
                    case 1:
                        value = _a.sent().allNodesSet[id.toString()];
                        return [4 /*yield*/, this.loadTownFromNode(value)];
                    case 2:
                        return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CNAddressMulti.prototype.renderCount = function (displayValues) {
        if (!this.state.value.length) {
            return null;
        }
        var locale = this.props.locale;
        var text = displayValues.map(function (n) {
            return n.label;
        }).join(", ");
        var trigger = locale.total(this.state.value.length);
        var Balloon = next_1.Balloon;
        // return trigger;
        return React.createElement(Balloon.Tooltip, { className: "next-cn-address-multi-allvalues", trigger: trigger, align: "b", text: text });
    };
    CNAddressMulti.prototype.getOverlayContainer = function () {
        var container = this.props.container;
        if (this.props.container) {
            if (typeof container == "function") {
                return container();
            }
            return container;
        }
        return this.refs.outerWrapper;
    };
    CNAddressMulti.prototype.triggerLabelUpdate = function (nodeValues, props) {
        var _this = this;
        if (props === void 0) {
            props = this.props;
        }
        if (typeof props.onLabelUpdate == "function") {
            var nodes = nodeValues.map(function (v) {
                return Common_2.anyValueToSelectionId(v);
            }).map(function (id) {
                return _this.allNodesSet[id.toString()];
            });
            props.onLabelUpdate.call(null, nodes.map(function (node) {
                return node.nameZh;
            }).join(", "), nodes);
        }
    };
    CNAddressMulti.prototype.normalizeSelection = function (ids) {
        var _this = this;
        // TODO: optimize this "deduplicate" process
        var iteration = function iteration(src) {
            var children = new _map2.default();
            var ret = [];
            src.forEach(function (id) {
                var parentId = _this.allNodesSet[id.toString()].parentNode.id;
                if (!children.has(parentId)) {
                    children.set(parentId, new _set2.default());
                }
                children.get(parentId).add(id);
            });
            var changed = false;
            children.forEach(function (v, k) {
                if (_this.allNodesSet[k.toString()].children.length == v.size) {
                    // changed = true;
                    // ret.push([ k ]); // 子节点为一个时，会获取父节点的 ID
                    ret.push((0, _from2.default)(v.values()));
                } else {
                    ret.push((0, _from2.default)(v.values()));
                }
            });
            if (changed) {
                return Array.prototype.concat.apply([], ret);
            } else {
                return false;
            }
        };
        var idsMerged = ids;
        while (true) {
            var t = iteration(idsMerged);
            if (!t) {
                break;
            } else {
                idsMerged = t;
            }
        }
        var ret = idsMerged.filter(function (id) {
            return !C.isDescendantOfOne(_this.allNodesSet, id, idsMerged);
        });
        return ret;
    };
    CNAddressMulti.prototype.renderCascader = function () {
        return React.createElement("div", { className: "next-cn-address-multi-overlay" }, React.createElement(CNAddressCascader_1.default, { addressTree: this.state.addressTree, allNodesSet: this.allNodesSet, expandedValue: this.state.expandedValue, onExpand: this.handleExpandChange, onChange: this.handleCascadeChange, value: this.state.value.map(function (node) {
                return lodash_alt_1.last(Common_2.selectionToChain(node));
            }), rootNodeId: Common_2.anyValueToSelectionId(this.props.root), level: this.props.level, hiddenMap: this.hiddenMap }));
    };
    CNAddressMulti.prototype.render = function () {
        var _this = this;
        var _a = this.props,
            className = _a.className,
            style = _a.style,
            placeholder = _a.placeholder,
            requestAddressUrl = _a.requestAddressUrl,
            requestTownUrl = _a.requestTownUrl,
            requestAddressLevelUrl = _a.requestAddressLevelUrl,
            level = _a.level,
            root = _a.root,
            onChange = _a.onChange,
            value = _a.value,
            hasClear = _a.hasClear,
            popupProps = _a.popupProps,
            popupClassName = _a.popupClassName,
            size = _a.size,
            rest = __rest(_a, ["className", "style", "placeholder", "requestAddressUrl", "requestTownUrl", "requestAddressLevelUrl", "level", "root", "onChange", "value", "hasClear", "popupProps", "popupClassName", "size"]);
        if (!this.allNodesSet) {
            return React.createElement("span", { key: "dataLoading", className: classNames("next-cn-address-loading", className), style: style }, rest.locale.loading);
        }
        // TODO: why casting to ReactComponent<any, any> does not work?
        var dataSourceRoot = !this.state.cascadeRootNodeID ? [] : this.datasetImmediate().allNodesSet[this.state.cascadeRootNodeID.toString()].children;
        var displayValues = this.state.value.map(function (v) {
            return _this.allNodesSet[Common_2.anyValueToSelectionId(v).toString()];
        }).map(function (n) {
            return { label: n.nameZh, value: n.id };
        });
        var CascaderSelect = next_1.CascaderSelect;
        var Select = next_1.Select;
        return React.createElement("span", { className: classNames("next-cn-address-multi-wrap", className, size), style: style, ref: "outerWrapper" }, React.createElement(Select, { className: classNames("next-cn-address-multi", { "next-cn-address-multi-nonempty": !!this.state.value.length }), size: size, placeholder: placeholder || rest.locale.placeholder, overlay: this.renderCascader(), visible: this.state.uiOverlayVisible, onVisibleChange: this.handleOverlayVisibleChange, onChange: this.handleCascadeChange, multiple: true, value: displayValues, hasClear: hasClear, container: this.getOverlayContainer, disabled: this.props.disabled, autoWidth: false, popupProps: popupProps, popupClassName: popupClassName }), this.renderCount(displayValues));
    };
    CNAddressMulti.propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])),
        defaultValue: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])),
        root: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
        level: PropTypes.number,
        disabled: PropTypes.bool,
        placeholder: PropTypes.node,
        requestAddressUrl: PropTypes.string,
        requestTownUrl: PropTypes.string,
        requestAddressLevelUrl: PropTypes.string,
        showItemCount: PropTypes.number,
        maxWidth: PropTypes.number,
        size: PropTypes.oneOf(["small", "medium", "large"]),
        hasClear: PropTypes.bool,
        container: PropTypes.func,
        ignored: PropTypes.arrayOf(PropTypes.string),
        dataOverride: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
        preprocessor: PropTypes.func,
        hiddenData: PropTypes.arrayOf(PropTypes.string),
        hasToSelectToLastLevel: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        onLabelUpdate: PropTypes.func,
        popupProps: PropTypes.object,
        popupClassName: PropTypes.string,
        _IS_CN_ADDRESS_MULTI_: PropTypes.bool
    };
    CNAddressMulti.defaultProps = {
        level: 4,
        requestAddressUrl: "//division-data.alicdn.com/simple/addr_4_1111_1_0.js",
        requestTownUrl: "//lsp.wuliu.taobao.com/locationservice/addr/output_address_town.do",
        requestAddressLevelUrl: "//lsp.wuliu.taobao.com/locationservice/addr/outputParentDivisons.do",
        root: "0",
        defaultValue: [],
        showItemCount: 8,
        maxWidth: 256,
        size: "medium",
        hasClear: false,
        container: null,
        ignored: [],
        dataOverride: {},
        preprocessor: Common_2.id,
        hiddenData: [],
        disabled: false,
        _IS_CN_ADDRESS_MULTI_: true
    };
    return CNAddressMulti;
}(React.Component);
// 国际化
var CNAddressMultiWithLocal = LocaleProvider(CNAddressMulti);
CNAddressMultiWithLocal.LOCALE = {
    'zh-cn': {
        loading: '加载数据中...',
        placeholder: '请选择地址',
        total: function total(len) {
            return React.createElement("span", { className: "next-cn-address-multi-total" }, "\u5171\xA0", React.createElement("span", { className: "next-cn-address-multi-total-num" }, len), "\xA0\u9879");
        }
    },
    'zh-tw': {
        loading: '加載數據中...',
        placeholder: '請選擇地址',
        total: function total(len) {
            return React.createElement("span", { className: "next-cn-address-multi-total" }, "\u5171\xA0", React.createElement("span", { className: "next-cn-address-multi-total-num" }, len), "\xA0\u9805");
        }
    },
    'en-us': {
        loading: 'loading data...',
        placeholder: 'please select an address',
        total: function total(len) {
            return React.createElement("span", { className: "next-cn-address-multi-total" }, React.createElement("span", { className: "next-cn-address-multi-total-num" }, len), "\xA0selected");
        }
    }
};
exports.default = CNAddressMultiWithLocal;
//# sourceMappingURL=CNAddressMulti.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/CNAddressMulti.js
// module id = 559
// module chunks = 0